import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Form as BsForm } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import { MultiSelect } from 'react-multi-select-component';
import noMessageIcon from '../../../assets/Images/no-order-table.png';
import { ModuleType } from '../../../constants/enums/module-type-enum';
import TrayStatusEnum from '../../../constants/enums/tray-status-enum';
import userSettingEnum from '../../../constants/enums/user-setting-enum';
import { GridRemoteConstant } from '../../../constants/grid-constant';
import { useStore } from '../../../contexts/store-provider';
import {
  OrderTableDefaultSortColumnOrder,
  OrderTableFilterInitialState,
} from '../../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage, getUserId } from '../../../helpers/localstorage-helper';
import IPageInfo, {
  IActionFormatter,
  IMultiSelectOption,
  IPageLimitInfo,
} from '../../../models/ICommon';
import IDefaultColumSortOrder from '../../../models/IDefaultColumSortOrder';
import { IOrderTableFilter } from '../../../models/IOrderTableFilter';
import { IActiveTrayProcessDue } from '../../../models/response/IActiveTrayResponse';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Grid from '../../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../../shared-components/Grid/GridFormatter';
import Pagination from '../../../shared-components/Grid/Pagination';
import Header from '../../../shared-components/header/header';
import FilterPopupHOC from '../../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../../shared-components/popup/delete/delete-popup-hoc';
import {
  DeleteIcon,
  EditIcon,
  RefreshIcon,
} from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';
import FilterComponent from './components/filter';
import LEDBlink from './components/led-blink';
import LEDBlinkPopupHOC from './hoc/led-blink-popup-hoc';
import './order-table-view.css';

const OrderTableView = (props: any) => {
  const {
    preferencesStore,
    trayManagementStore,
    dashboardStore,
    activeTrayManagementStore,
    processStore,
    operatorStore,
  } = useStore();
  const {
    deleteTrayState,
    trayState,
    DeleteTrayService,
    resetTrayDetail,
    addUpdateTrayState,
  } = trayManagementStore;

  const {
    GetOrderTableViewListService,
    getOrderTableListServiceState,
    allOrderTableView,
    orderList,
    ledBlinkState,
    resetLedBlinkState,
    resetGetOrderTableListServiceState,
    GetColumnListService,
    getColumnListServiceState,
    columnListDetails,
    allProcessHeaders,
    visibleOrderTableColumnsList,
  } = dashboardStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  const {
    SaveProcessOrderService,
    saveProcessOrderState,
    resetSaveProcessOrderState,
  } = activeTrayManagementStore;

  const { allFactoryProcess, GetAllProcessService, allProcessOptions, nextProcessOptions } =
    processStore;

    const {GetAssignedProcessListService, getAssignedProcessListState, allAssignedTasksNextProcessOptions} = operatorStore;

  let lang: string;
  let allTrayListData = allOrderTableView;
  const [allowedColumns, setAllowedColumns] = useState(['checkbox']);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    OrderTableDefaultSortColumnOrder
  );

  // const MAX_RECORDS_LENGTH = 5;
  const [allGroupSettingsListData, setAllGroupSettingsListData] = useState<
    any[]
  >([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (visibleOrderTableColumnsList) {
      setSelected([...visibleOrderTableColumnsList]);
      setAllowedColumns([
        ...visibleOrderTableColumnsList.map((column) => column.value),
      ]);
    }
  }, [visibleOrderTableColumnsList]);

  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [filterObj, setFilterObj] = useState<IOrderTableFilter>(
    OrderTableFilterInitialState
  );
  const [selectedIds, setSelectedIds] = useState<any[]>([]);
  const [orderViewColumnFields, setOrderViewColumnFields] = useState<
    IMultiSelectOption[]
  >([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [showAssigedTags, setShowAssigedTags] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [showCompletedTrays, setShowCompletedTrays] = useState(false);
  type TagViewMode = 'normal' | 'assigned' | 'completed';

  const [tagViewMode, setTagViewMode] = useState<TagViewMode>('normal');

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };
  const getOrderTrayListServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }
    if (!isFilter) {
      GetOrderTableViewListService(
        Number(getTenantIdFromLocalStorage()),
        pageLimitInfo.pageLimit,
        pageInfo.currentPage,
        encodeURIComponent(filterQuery)
      );
    } else {
      GetOrderTableViewListService(
        Number(getTenantIdFromLocalStorage()),
        pageLimitInfo.pageLimit,
        1,
        encodeURIComponent(filterQuery)
      );
    }
  };

  useEffect(() => {
    GetColumnListService(Number(getTenantIdFromLocalStorage()));
    // GetAllProcessService(Number(getTenantIdFromLocalStorage()));
    GetAssignedProcessListService(Number(getUserId()), userSettingEnum.OperatorTaskOrder, userSettingEnum.HiddenProcessList);
  }, []);

  useEffect(() => {
    if (getColumnListServiceState.success) {
      setOrderViewColumnFields([...columnListDetails]);
    }
  }, [getColumnListServiceState.success]);

  const openLEDHandler = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    props.addToggleHandler();
    resetTrayDetail();
  };

  useEffect(() => {
    getOrderTrayListServiceHandler();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: orderList?.PagingDetails?.CurrentPage,
      totalPages: orderList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [orderList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getOrderTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getOrderTrayListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  // useEffect(() => {
  //   if (selectedRows.length > MAX_RECORDS_LENGTH) {
  //     toast.error(formatMessage('max_records_allowed_5'));
  //   }
  // }, [selectedRows]);

  useEffect(() => {
    if (lang && language !== lang) {
      getOrderTrayListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (ledBlinkState.success) {
      toast.success(formatMessage('added_success'));
      // setAllGroupSettingsListData([]);
      setSelectedRows([]);
      resetGetOrderTableListServiceState();
      resetLedBlinkState();
      // getOrderTrayListServiceHandler();
      // setSelectedIds([]);
    }
  }, [ledBlinkState.success]);

  useEffect(() => {
    if (ledBlinkState.error) {
      toast.error(formatMessage(ledBlinkState.error));
      resetLedBlinkState();
      // setSelectedIds([]);
      getOrderTrayListServiceHandler();
    }
  }, [ledBlinkState.error]);

  useEffect(() => {
    if (getOrderTableListServiceState.success) {
      setAllGroupSettingsListData(allOrderTableView);
      resetGetOrderTableListServiceState();
    }
  }, [getOrderTableListServiceState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }

    if (row.CurrentState === TrayStatusEnum.Complete) {
      className = 'active-tray-row';
    }

    return className;
  }

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    const filter = createQueryString({
      ...filterObj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    setSelectedIds([])
    getOrderTrayListServiceHandler(filter);
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteTrayService(Number(getTenantIdFromLocalStorage()), selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetTrayDetail();
    props.deletePopupToggleHandler();
  };

  function getFieldName(field: string): string {
    switch (field) {
      case 'TrayId':
        return 'tray_id';
      case 'OrderId':
        return 'order_id';
      case 'EUOrderNo':
        return 'eu_order_no';
      case 'CustomerDueDate':
        return 'customer_due_date';
      case 'PlanedDueDate':
        return 'planed_due_date';
      case 'ProductId':
        return 'product_id';
      case 'CustomerId':
        return 'customer_id';
      default:
        return 'tray_id';
    }
  }

  const createQueryString = (filter: IOrderTableFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const processColumns = allProcessHeaders.map(
    (process: IActiveTrayProcessDue, _: number) => {
      return {
        dataField: process.ProcessName,
        text: formatMessage(process.ProcessName.slice(0, 20)),
        classes: '',
        headerFormatter: (column) => {
          return (
            <span
              title={process.ProcessName}
              className="process-headers-formatter"
            >
              {column.text}
            </span>
          );
        },
        formatter: function (cell, row, rowIndex, columnIndex, column) {
          let isDone = cell === 'done';
          return (
            <div className={`${isDone ? 'null-class badge' : ''}`}>
              {cell && cell !== 'N/A' ? (cell === 'done' ? 'Done' : cell) : '-'}
            </div>
          );
        },
        title: (cell: string) => {
          return cell && cell.length > 10 ? cell : undefined;
        },
        sort: false,
      };
    }
  );

  const filterHandler = (object: IOrderTableFilter) => {
    const filter = createQueryString({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
      ShowAssigned: tagViewMode === 'assigned',
      IsTrayCompleted: tagViewMode === 'completed',
    });
    getOrderTrayListServiceHandler(filter, true);
    setFilterObj({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
      ShowAssigned: showAssigedTags,
      IsTrayCompleted: showCompletedTrays,
    });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const filterParams = (obj: IOrderTableFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
      ShowAssigned: isFilterCleared ?? false,
      IsTrayCompleted: isFilterCleared ?? false
    });
    if (isfilterCleard) {
      setFilterObj({ ...obj });
      setTagViewMode('normal')
      getOrderTrayListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  // useEffect(() => {
  //   if (selectedIds.length > MAX_RECORDS_LENGTH) {
  //     toast.error(formatMessage('max_records_allowed_5'));
  //   }
  // }, [selectedIds]);

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'EndUserName',
      text: formatMessage('end_user_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'EndUserOrderId',
      text: formatMessage('end_user_order_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'OrderId',
      text: formatMessage('order_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Kishu',
      text: formatMessage('kishu'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'TrayId',
      text: formatMessage('tray_id'),
      classes: 'show-Elipses',
      sort: true,
    },
    {
      dataField: 'ProductId',
      text: formatMessage('product_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Katashiki1',
      text: formatMessage('katashiki_1'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Katashiki2',
      text: formatMessage('katashiki_2'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'MaterialProductId',
      text: formatMessage('material_product_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      // sort: true,
    },

    {
      dataField: 'MaterialKatashiki',
      text: formatMessage('material_katashiki'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      // sort: true,
    },
    {
      dataField: 'Quantity',
      text: formatMessage('quantity'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'CustomerId',
      text: formatMessage('customer_id'),
      classes: 'show-Elipses',
      sort: true,
    },
    {
      dataField: 'SubContractor',
      text: formatMessage('sub_contractor'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'SubContractorName',
      text: formatMessage('sub_contractor_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProcessName',
      text: formatMessage('process_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'InvoiceNumber',
      text: formatMessage('invoice_number'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'QuantityUnitName',
      text: formatMessage('quantity_unit_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'MissingParts',
      text: formatMessage('missing_parts'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment1',
      text: formatMessage('product_comment_1'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment2',
      text: formatMessage('product_comment_2'),
      classes: 'show-Elipses',
      title: (cell) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment3',
      text: formatMessage('product_comment_3'),
      classes: 'show-Elipses',
      title: (cell) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment4',
      text: formatMessage('product_comment_4'),
      classes: 'show-Elipses',
      title: (cell) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment5',
      text: formatMessage('product_comment_5'),
      classes: 'show-Elipses',
      title: (cell) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment6',
      text: formatMessage('product_comment_6'),
      classes: 'show-Elipses',
      title: (cell) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'CustomerDueDate',
      text: formatMessage('customer_due_date'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'PlanedDueDate',
      text: formatMessage('planned_due_dates'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      hidden: true,
      sort: true,
    },
    {
      dataField: 'PreviousProcess',
      text: formatMessage('previous_process'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      // sort: true,
    },
    {
      dataField: 'NextProcess',
      text: formatMessage('next_process'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      // sort: true,
    },
    ...processColumns,
  ];

  const filteredColumns = columns.filter((col: any) =>
    allowedColumns.includes(col.dataField)
  );

  const handleSelectionChange = async (selectedOptions) => {
    if (selectedOptions.length === 0) {
      setSelected([]);
      setAllowedColumns([
        // ...initialSelection.map((item) => item.value),
        // 'checkbox',
      ]);
    } else {
      setSelected(selectedOptions);
      setAllowedColumns([
        ...selectedOptions.map((item) => item.value),
        'checkbox',
      ]);
    }

    SaveProcessOrderService({
      SettingKey: userSettingEnum.OrderTableColumn,
      ProcessOrder: selectedOptions.map((opt) => opt.value).join(','),
    });
  };

  useEffect(() => {
    if (saveProcessOrderState.error) {
      toast.error(formatMessage(saveProcessOrderState.error));
      resetSaveProcessOrderState();
    }
  }, [saveProcessOrderState.error]);

  useEffect(() => {
    if (saveProcessOrderState.success) {
      // toast.success(formatMessage('updated_success'));
      getOrderTrayListServiceHandler();
      resetSaveProcessOrderState();
    }
  }, [saveProcessOrderState.success]);

  const nonSelectableIds = allGroupSettingsListData
    .filter((row) => row.CurrentState === 'Complete')
    .map((row) => row.TrayId);

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selectedIds,
    nonSelectable: [...nonSelectableIds],
    selectionRenderer: ({ mode, checked, disabled }: any) => (
      <input
        type={mode}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        readOnly
      />
    ),
    selectionHeaderRenderer: ({ checked, indeterminate }: any) => (
      <input
        type="checkbox"
        checked={checked}
        ref={(input: HTMLInputElement | null) => {
          if (input) input.indeterminate = indeterminate;
        }}
        className="form-check-input"
        readOnly
      />
    ),
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedIds((prev) => [...prev, row.TrayId]);
      } else {
        setSelectedIds((prev) =>
          prev.filter((TrayId) => TrayId !== row.TrayId)
        );
      }
    },

    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows.map((row) => row.TrayId);
        setSelectedIds(allIds);
      } else {
        setSelectedIds([]);
      }
    },
  };

  const toggleShowAssignedTags = (e: any) => {
    setSelectedIds([]);
    const queryString = createQueryString({
      ...filterObj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
      ShowAssigned: e.target.checked,
    });
    setShowAssigedTags(!showAssigedTags);
    setFilterObj((prev) => ({
      ...prev,
      ShowAssigned: e.target.checked,
    }));
    getOrderTrayListServiceHandler(queryString, true);
  };

  const toggleShowCompletedTrays = (e: any) => {
    setSelectedIds([]);
    const queryString = createQueryString({
      ...filterObj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
      IsTrayCompleted: e.target.checked,
    });
    setShowCompletedTrays(!showCompletedTrays);
    setFilterObj((prev) => ({
      ...prev,
      IsTrayCompleted: e.target.checked,
    }));
    getOrderTrayListServiceHandler(queryString, true);
  };

  const handleTagViewChange = (mode: TagViewMode) => {
    setSelectedIds([]);
    setTagViewMode(mode);

    const queryString = createQueryString({
      ...filterObj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
      ShowAssigned: mode === 'assigned',
      IsTrayCompleted: mode === 'completed',
    });

    setFilterObj((prev) => ({
      ...prev,
      ShowAssigned: mode === 'assigned',
      IsTrayCompleted: mode === 'completed',
    }));

    getOrderTrayListServiceHandler(queryString, true);
  };

  const handleTableChange = (type: any, newState: any) => {
    if(newState.sortField !== columSortOrder.dataField || newState.sortOrder !== columSortOrder.order){
      setColumnSortOrder({
        ...columSortOrder,
        dataField: newState.sortField,
        order: newState.sortOrder,
      });
      const filter = createQueryString({
        ...filterObj,
        Column: newState.sortField,
        Order: newState.sortOrder,
      });
      getOrderTrayListServiceHandler(filter, true);
    }
    // setColumnSortOrder({
    //     ...columSortOrder,
    //     dataField: newState.sortField,
    //     order: newState.sortOrder,
    //   });
    //   const filter = createQueryString({
    //     ...filterObj,
    //     Column: newState.sortField,
    //     Order: newState.sortOrder,
    //   });
    //   getOrderTrayListServiceHandler(filter, true);
  };

  // useEffect(() => {
  //   const filter = createQueryString({
  //     ...filterObj,
  //     Column: columSortOrder.dataField,
  //     Order: columSortOrder.order,
  //   });

  //   getOrderTrayListServiceHandler(filter);
  // }, [columSortOrder]);

  return (
    <>
      {props.showLEDBlinkPopup && (
        <LEDBlink
          id={selectedId}
          modalClosed={props.addToggleHandler}
          selectedRows={selectedIds.map((row) => row)}
        />
      )}

      {props.showDeletePopup && (
        <DeletePopup
          title="delete_tray"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_tray_confirm"
          isLoading={deleteTrayState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center order-table">
          <Header
            className="col-auto"
            label="order_table"
          />

          <div className="col">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isLoading={false}
                  isDisable={false}
                  isFilterCleared={isFilterCleared}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                  allFactoryProcess={allAssignedTasksNextProcessOptions}
                />
              </li>
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              {/* <li
                title={`${formatMessage('show_tags_assigned')}`}
                className="d-flex align-items-center g-2 ms-4 ps-1 show-group"
              >
                <BsForm.Check
                  type="switch"
                  id="custom-switch"
                  className="btn"
                  checked={showAssigedTags}
                  readOnly
                  onClick={(e: any) => toggleShowAssignedTags(e)}
                />
                <p className="auto-refresh text-white">
                  {formatMessage('show_tags_assigned')}
                </p>
              </li> */}
               {isOperationPermittedRoleBase(
                ModuleType.OrderViewDashboard,
                'Add'
              ) && (
                  <li
                    title={formatMessage('led_title')}
                    className="process-chart"
                  >
                    <a
                      className={`btn btn-secondary ${selectedIds.length === 0
                          ? // || selectedIds.length > MAX_RECORDS_LENGTH
                          'disabled'
                          : ''
                        }`}
                      data-toggle="modal"
                      data-testid="modalbtn"
                      data-target="#addUser"
                      onClick={(event: any) => openLEDHandler(event)}
                    >
                      <FormattedMessage id="led_title" />
                    </a>
                  </li>
                )}
              <ul className="tableAccordian-switch d-flex">
                <li
                  className={tagViewMode === 'normal' ? 'active' : ''}
                  onClick={() => {
                    localStorage.setItem('toggleView', JSON.stringify(false));
                    handleTagViewChange('normal')
                  }}
                >
                  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" id="fi_18975621"><g clip-rule="evenodd" fill-rule="evenodd"><path d="m11.5 22v-20h1v20z"></path><path d="m22 12.5h-20v-1h20z"></path><path d="m1.5 2c0-.27614.22386-.5.5-.5h20c.2761 0 .5.22386.5.5v20c0 .2761-.2239.5-.5.5h-20c-.27614 0-.5-.2239-.5-.5zm1 .5v19h19v-19z"></path></g></svg>
                  <span className="icon-text">{formatMessage('default_view')}</span>{' '}
                </li>
                <li
                  className={tagViewMode === 'assigned' ? 'active' : ''}
                  onClick={() => {
                    // localStorage.setItem('toggleView', JSON.stringify(true));
                    // getHolidayListServiceHandler();
                    handleTagViewChange('assigned')
                  }}
                >
                  <svg id="fi_14058098" enable-background="new 0 0 24 24" height="30" viewBox="0 0 24 24" width="30" xmlns="http://www.w3.org/2000/svg"><g><g><g><path d="m1.6 17.4c-.3 0-.5-.2-.5-.4v-5.8c0-.3.2-.5.5-.5h3.3c1.5 0 2.7 1.2 2.7 2.7v.8c0 .3-.2.5-.4.5-.3 0-.5-.2-.5-.5v-.8c0-1-.8-1.8-1.8-1.8h-2.8v5.4c0 .2-.2.4-.5.4z"></path></g><g><path d="m22.3 17.4c-.2 0-.4-.2-.4-.4v-5.4h-2.9c-1 0-1.8.8-1.8 1.8v.8c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-.8c0-1.5 1.2-2.7 2.8-2.7h3.3c.2 0 .4.2.4.5v5.8c.1.2-.1.4-.4.4z"></path></g><g><path d="m15.9 15.5h-7.8c-.7 0-1.3-.6-1.3-1.3 0-.2.2-.5.5-.5.2 0 .4.2.4.5 0 .2.2.4.4.4h7.8c.2 0 .4-.1.4-.4 0-.2.2-.5.5-.5s.5.2.5.5c-.1.7-.7 1.3-1.4 1.3z"></path></g><g><path d="m20.1 20.2h-16.2c-1.5 0-2.8-1.2-2.8-2.8v-1.4c0-.2.2-.5.5-.5s.5.2.5.5v1.4c0 1 .8 1.9 1.8 1.9h16.1c1 0 1.8-.8 1.8-1.9v-1.4c0-.2.2-.5.4-.5s.4.2.4.5v1.4c.2 1.5-1 2.8-2.5 2.8z"></path></g></g><g><path d="m22.3 11.5c-.2 0-.3-.1-.4-.2l-4.3-6.5h-11.3l-4.3 6.5c-.1.2-.4.3-.6.1s-.2-.4-.1-.6l4.5-6.7c0-.1.2-.2.3-.2h11.8c.2 0 .3.1.4.2l4.5 6.7c.1.2.1.5-.1.6s-.3.1-.4.1z"></path></g></g></svg>
                  <span className="icon-text">{formatMessage('show_tags_assigned')}</span>
                </li>
                <li
                  className={tagViewMode === 'completed' ? 'active' : ''}
                  onClick={() => {
                    // localStorage.setItem('toggleView', JSON.stringify(true));
                    // getHolidayListServiceHandler();
                    handleTagViewChange('completed')
                  }}
                >
                  <svg id="fi_18450767" enable-background="new 0 0 100 100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="m77.5180588 9.9200459h-55.0361195c-3.0706234 0-5.7967033 1.964983-6.7675276 4.8780966l-12.8484966 38.5539388c-.2423596.7272415-.3659163 1.4887886-.3659163 2.2553482v27.3390808c0 3.9396896 3.1937516 7.1334457 7.1334438 7.1334457h80.7331085c3.9397004.0000001 7.1334489-3.193756 7.1334489-7.1334457v-27.3390808c0-.7665596-.123558-1.5281067-.3659134-2.2553482l-12.8484955-38.5539389c-.9708252-2.9131136-3.696907-4.8780965-6.7675323-4.8780965zm-13.8581467 44.5300273c-1.1899414 2.5300293-3.0499268 4.75-5.3898926 6.3498535-2.3300781 1.6000977-5.1500244 2.5600587-8.2700195 2.5600587-5.9399414 0-11.2800293-3.5600586-13.6599121-8.9099121h-22.2600107l10.6899424-32.6501465h50.4599609l10.6899414 32.6501465h-22.2600098z"></path></svg>   <span className="icon-text">{formatMessage('show_completed_trays')}</span>
                </li>
              </ul>

              <li>
                <MultiSelect
                  options={orderViewColumnFields.map((field) => ({
                    ...field,
                    label: formatMessage(field.label),
                  }))}
                  value={selected}
                  onChange={handleSelectionChange}
                  labelledBy="Select"
                  className={`multiselect-react product-select ${allTrayListData.length === 0 ? 'div-disabled' : ''}`}
                  valueRenderer={() => formatMessage('select_columns')}
                  overrideStrings={{
                    selectAll: formatMessage('select_all_options'),
                    search: formatMessage('search'),
                  }}
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getOrderTableListServiceState.inProgress ||
            trayState.inProgress ||
            deleteTrayState.inProgress ||
            addUpdateTrayState.inProgress ||
            ledBlinkState.inProgress ||
            getColumnListServiceState.inProgress) && (
              <FormLoader
                loading={
                  getOrderTableListServiceState.inProgress ||
                  trayState.inProgress ||
                  deleteTrayState.inProgress ||
                  addUpdateTrayState.inProgress ||
                  ledBlinkState.inProgress ||
                  getColumnListServiceState.inProgress
                }
              />
            )}
          {allGroupSettingsListData &&
            allGroupSettingsListData.length > 0 &&
            allowedColumns.length > 0 &&
            filteredColumns.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {allGroupSettingsListData && (
                      <Grid
                        data={allGroupSettingsListData}
                        columns={filteredColumns}
                        loading={false}
                        rowClasses={rowClassFormat}
                        hover={true}
                        selectRow={selectRow}
                        keyField="TrayId"
                        remote={{ ...GridRemoteConstant }}
                        onTableChange={handleTableChange}
                        sort={{ ...columSortOrder }}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allGroupSettingsListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={orderList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage
                      id={
                        allowedColumns.length > 0
                          ? 'no_order_added'
                          : 'no_column_selected'
                      }
                    />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage(
                      allowedColumns.length > 0
                        ? 'no_order_table_message'
                        : 'please_select_a_column'
                    )}
                  </h4>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LEDBlinkPopupHOC(
  FilterPopupHOC(DeletePopupHOC(observer(OrderTableView)))
);
